import LoyaltyCardProductsScreen from "@/loyalty-card/views/LoyaltyCardProductsScreen.vue";
import LoyaltyCardRewardsScreen from "@/loyalty-card/views/LoyaltyCardRewardsScreen.vue";
import LoyaltyCardMigrationScreen from "@/loyalty-card/views/LoyaltyCardMigrationScreen.vue";
import LoyaltyCardRulesScreen from "@/loyalty-card/views/LoyaltyCardRulesScreen.vue";

const loyaltyCardRouter = [
    {
        path: 'loyalty-cards/:loyaltyCardId/products',
        name: 'program.loyalty-card.products',
        component: LoyaltyCardProductsScreen,
        props: true
    },
    {
        path: 'loyalty-cards/:loyaltyCardId/rewards',
        name: 'program.loyalty-card.rewards',
        component: LoyaltyCardRewardsScreen,
        props: true
    },
    {
        path: 'loyalty-cards/:loyaltyCardId/rules',
        name: 'program.loyalty-card.rules',
        component: LoyaltyCardRulesScreen,
        props: true
    },
    {
        path: 'loyalty-cards/:loyaltyCardId/migration',
        name: 'program.loyalty-card.migration',
        component: LoyaltyCardMigrationScreen,
        props: true
    }
];

export default loyaltyCardRouter;
